"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reversePlaceholders = void 0;
function reversePlaceholders(str, template) {
    const keys = [];
    let match;
    const regex = /{{(\w+)}}/g;
    while ((match = regex.exec(template)) !== null)
        keys.push(match[1]);
    const pattern = template.replace(/\./g, "\\.").replace(/{{.*?}}/g, "(.*)");
    let output = {};
    const values = new RegExp(`^${pattern}$`).exec(str)?.slice(1);
    if (!values)
        throw new Error(`template is not matching the input string`);
    return keys.reduce((output, key, index) => Object.assign(output, { [key]: values[index] }), output);
}
exports.reversePlaceholders = reversePlaceholders;
